<template>
    <div class="error-warning-update">
        <dl
            id="detailList"
            class="">
            <dt>Agency Name:</dt>
            <dd>
                {{ dataItem.agency }}
            </dd>
            <dt>Agency Ori:</dt>
            <dd>
                {{ dataItem.ori }}
            </dd>
            <dt>{{ incidentNumberLabel }}:</dt>
            <dd>
                {{ idValue }}
            </dd>
            <dt>Error/Warning description:</dt>
            <dd>
                <span>{{ typeAndCode }}</span> - {{ errorDesc }}
            </dd>
            <dt>Status:</dt>
            <dd>
                <div class="d-inline-block">
                    <div
                        class="form-check"
                        v-for="status in statusList">
                        <input
                            class="form-check-input"
                            type="radio"
                            :name="status.id"
                            :id="status.id"
                            :value="status.value"
                            v-model="statusValue"
                            required />
                        <label
                            class="form-check-label"
                            :for="status.id">
                            {{ status.text }}
                        </label>
                    </div>
                </div>
            </dd>
        </dl>
        <dl v-if="statusValue == '1'">
            <dt>Explanation/Justification:</dt>
            <dd>
                <textarea
                    :class="
                        getRequiredCssClass('form-control', explanationValue != null && explanationValue.length > 0)
                    "
                    rows="5"
                    style="width: 80%"
                    v-model="explanationValue"
                    required></textarea>
            </dd>
        </dl>
        <div v-if="dataItem['isAcknowledged'] && statusValue == '1'">
            <dl>
                <dt>
                    Action date:
                    <label id="ActiondateValue"></label>
                </dt>
                <dd>
                    {{ dataItem["acknowledgedOn"] }}
                </dd>
                <dt>Actioned by:</dt>
                <dd>
                    {{ dataItem["acknowledgedBy"] }}
                </dd>
            </dl>
        </div>
        <div class="hstack gap-2">
            <button
                class="btn btn-primary"
                @click.prevent="handleConfirmClick()">
                Update
            </button>
            <button
                class="btn btn-danger"
                @click.prevent="handleDismissClick()">
                Cancel
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import {computed, ref, watch, defineProps, defineEmits, onMounted} from "vue";
import {useGlobalMessagesStore} from "@/stores/globalMessagesStore";
import axios from "axios";
import {handleError} from "@/stores/storeHelper";
const globalMessages = useGlobalMessagesStore();
//props and variables
const props = withDefaults(
    defineProps<{
        item: any;
        url: string;
        dataset: string;
        uploadHeaders?: any;
    }>(),
    {
        uploadHeaders: {},
    }
);

const emit = defineEmits<{
    (e: "dismiss"): void;
}>();

const statusList = [
    {id: "unresolved", text: "Unresolved", value: "0"},
    {id: "dismissed", text: "Dismissed/Cleared", value: "1"},
];
var statusValue = ref("");
var explanationValue = ref("");
var dataItem = ref({} as any);

//computed properties
const incidentNumberLabel = computed(() => {
    if (props.dataset?.toLocaleLowerCase() == "communityPolicing") {
        return "Stop Number";
    }

    return "Incident Number";
});
const typeAndCode = computed(() => {
    return `${dataItem.value["errorType"]} ${dataItem.value["errorCode"]}`;
});
const errorDesc = computed(() => {
    return dataItem.value["description"];
});
const idValue = computed(() => {
    return props.dataset == "communityPolicing" ? dataItem.value["stopNumber"] : dataItem.value["incidentNumber"];
});

//methods section
async function handleConfirmClick() {
    if (
        statusValue.value != null &&
        explanationValue.value != null &&
        statusValue.value.length > 0 &&
        explanationValue.value.length > 0
    ) {
        let dataToPost = {
            id: dataItem.value.id,
            status: statusValue.value,
            explanation: explanationValue.value,
            code: dataItem.value["errorCode"],
        };

        try {
            await axios.post(props.url, dataToPost, {
                headers: props.uploadHeaders,
            });
            globalMessages.push({message: "Error or warning updated successfully.", type: "success"});
        } catch (error) {
            handleError(error);
            throw error;
        } finally {
            handleDismissClick();
        }
    }
}
function handleDismissClick() {
    emit("dismiss");
}

function getData() {
    if (props.item != null) {
        dataItem.value = props.item;
    }
}

function getRequiredCssClass(baseCssClasses, isValid) {
    if (isValid) {
        return baseCssClasses;
    }

    return baseCssClasses + " is-invalid";
}

watch(
    () => props.item,
    (item, prevItem) => {
        if (item != null) {
            dataItem.value = item;

            if (dataItem.value["isAcknowledged"]) {
                statusValue.value = "1";
            } else {
                statusValue.value = "0";
            }

            explanationValue.value = dataItem.value["explanation"];
        }
    }
);
</script>
